import React from "react";
import { Box, Loader } from "@mantine/core";

export interface BlurLoadingOverlayProps {
  /** When true, covers the viewport with a blurred backdrop + centered spinner. */
  visible: boolean;
  /** z-index; default sits above modals/drawers so it reads as a page-level wait. */
  zIndex?: number;
}

/**
 * Fixed, full-viewport blurred overlay with the standard Mantine spinner in the
 * middle. Used while a click is waiting on an async load (e.g. fetching a
 * transaction before its detail modal opens). `backdrop-filter` has no Mantine
 * prop, so it lives in `style`.
 */
const BlurLoadingOverlay: React.FC<BlurLoadingOverlayProps> = ({
  visible,
  zIndex = 3000,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Box
      pos="fixed"
      style={{
        inset: 0,
        zIndex,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(2px)",
        WebkitBackdropFilter: "blur(2px)",
        backgroundColor: "rgba(255, 255, 255, 0.35)",
        cursor: "wait",
      }}
    >
      <Loader color="var(--brand-teal)" />
    </Box>
  );
};

export default BlurLoadingOverlay;
